import { createSlice } from '@reduxjs/toolkit';
import { sectors } from 'client/store/layersSlice/layersSlice';

export const DEFAULT_OWNER_STATE = {
    [sectors.ELECTRICITY]: false,
    [sectors.GAS]: false,
    descriptions: true,
    dimensions: true,
    overlapping: false,
    standardMap: true,
    customMap: false
};

const initialState = {
    selectedOwnerId: null,
    selectedAssetCategory: null,
    category: null,
    owners: {}
};

const isolatedViewsSlice = createSlice({
    name: 'isolatedViews',
    initialState,
    reducers: {
        initialiseOwnerState: (state, action) => {
            const ownerId = action.payload;
            if (!ownerId) { return; }

            if (!state.owners[ownerId]) {
                state.owners[ownerId] = { ...DEFAULT_OWNER_STATE };
            }
        },
        setSelectedOwnerId: (state, action) => {
            state.selectedOwnerId = action.payload ?? null;
        },
        resetSelectedOwnerId: (state) => {
            state.selectedOwnerId = null;
        },
        setSelectedAssetCategory: (state, action) => {
            const selection = action.payload;
            if (selection && typeof selection === 'object') {
                state.selectedAssetCategory = selection.id ?? null;
                state.category = selection.category ?? null;
                return;
            }

            state.selectedAssetCategory = selection ?? null;
            state.category = null;
        },
        setOwnerPreference: (state, action) => {
            const { ownerId, key, value } = action.payload || {};
            if (!ownerId || !key) { return; }

            if (!state.owners[ownerId]) {
                state.owners[ownerId] = { ...DEFAULT_OWNER_STATE };
            }

            state.owners[ownerId][key] = value;
        },
        setOwnerPreferences: (state, action) => {
            const { ownerId, patch } = action.payload || {};
            if (!ownerId || !patch || typeof patch !== 'object') { return; }

            if (!state.owners[ownerId]) {
                state.owners[ownerId] = { ...DEFAULT_OWNER_STATE };
            }

            state.owners[ownerId] = {
                ...state.owners[ownerId],
                ...patch
            };
        },
        resetOwnerState: (state, action) => {
            const ownerId = action.payload;
            if (!ownerId) { return; }
            state.owners[ownerId] = { ...DEFAULT_OWNER_STATE };
        },
        resetIsolatedViewsState: () => ({
            ...initialState,
            owners: {}
        })
    }
});

export const {
    initialiseOwnerState,
    setSelectedOwnerId,
    resetSelectedOwnerId,
    setSelectedAssetCategory,
    setOwnerPreference,
    setOwnerPreferences,
    resetOwnerState,
    resetIsolatedViewsState
} = isolatedViewsSlice.actions;

export const selectSelectedOwnerId = state => state?.isolatedViews?.selectedOwnerId ?? null;
export const selectSelectedAssetCategory = state => state?.isolatedViews?.selectedAssetCategory ?? null;
export const selectSelectedAssetCategoryName = state => state?.isolatedViews?.category ?? null;
export const selectOwnerState = (state, ownerId) => state?.isolatedViews?.owners?.[ownerId] ?? { ...DEFAULT_OWNER_STATE };

export default isolatedViewsSlice.reducer;
